import { Component, ElementRef, Input, OnChanges, ViewChild, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-pdf-canvas-viewer',
  template: `<canvas #canvas></canvas>`,
  styles: [`canvas { width: 100%; height: auto; }`],
  standalone: true
})
export class PdfCanvasViewerComponent implements OnChanges {

  @Input() base64!: string;
  @ViewChild('canvas', { static: false }) canvasRef!: ElementRef<HTMLCanvasElement>;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  async ngOnChanges() {
    if (!this.base64 || !isPlatformBrowser(this.platformId)) return;
    const pdfjsLib = await import('pdfjs-dist/legacy/build/pdf');
    pdfjsLib.GlobalWorkerOptions.workerSrc = '/assets/pdfjs/pdf.worker.min.js';

    const raw = this.base64.startsWith('data:')
      ? atob(this.base64.split(',')[1])
      : atob(this.base64);

    const uint8 = new Uint8Array([...raw].map(c => c.charCodeAt(0)));

    const pdf = await pdfjsLib.getDocument({ data: uint8 }).promise;
    const page = await pdf.getPage(1);

    const viewport = page.getViewport({ scale: 1.2 });
    const canvas = this.canvasRef.nativeElement;
    const ctx = canvas.getContext('2d')!;

    canvas.width = viewport.width;
    canvas.height = viewport.height;

    await page.render({ canvasContext: ctx, viewport }).promise;
  }
}
